<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">
          <span>
            Test Message
          </span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="testNumber"
                v-mask="'(###) ###-####'"
                placeholder="(___) ___-____"
                required
                label="Cell Number *"
                :error="!(testNumber && testNumber.length) && isFormDirty"
              />
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="_close">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="_submit">
          Send Message
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import Vue from "vue";
import { VueMaskDirective } from "v-mask";

Vue.directive("mask", VueMaskDirective);

export default {
  name: "MessageTestNumberInputDialog",
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    testNumber: "",
    snackbar: false,
    notification: "Unknown"
  }),

  watch: {
    isVisible(val) {
      if (!val) {
        this.testNumber = "";
      }
    }
  },

  created() {},

  methods: {
    _submit() {
      const parsedNumber = this._parseCellNumberFromMaskFormat(this.testNumber);
      if (parsedNumber.length === 10) {
        this.$emit("send-test-message", parsedNumber);
      } else {
        this.notification = "Enter a valid number";
        this.snackbar = true;
      }
    },
    _parseCellNumberFromMaskFormat(cellNumber) {
      return cellNumber.replace(/[^0-9,]+/g, "");
    },
    _close() {
      this.$emit("hide");
      this.field = Object.assign({
        testNumber: ""
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
